"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExpressionVariables = getExpressionVariables;
const utils_algebra_1 = require("@comunica/utils-algebra");
const rdf_terms_1 = require("rdf-terms");
/**
 * Get all variables inside the given expression.
 * @param expression An expression.
 * @return An array of variables, which can be empty.
 */
function getExpressionVariables(expression) {
    if ((0, utils_algebra_1.isKnownSubType)(expression, utils_algebra_1.Algebra.ExpressionTypes.EXISTENCE)) {
        return utils_algebra_1.algebraUtils.inScopeVariables(expression.input);
    }
    if ((0, utils_algebra_1.isKnownSubType)(expression, utils_algebra_1.Algebra.ExpressionTypes.NAMED)) {
        return [];
    }
    if ((0, utils_algebra_1.isKnownSubType)(expression, utils_algebra_1.Algebra.ExpressionTypes.OPERATOR)) {
        return (0, rdf_terms_1.uniqTerms)(expression.args.flatMap(arg => getExpressionVariables(arg)));
    }
    if ((0, utils_algebra_1.isKnownSubType)(expression, utils_algebra_1.Algebra.ExpressionTypes.TERM)) {
        if (expression.term.termType === 'Variable') {
            return [expression.term];
        }
        return [];
    }
    throw new Error(`Getting expression variables is not supported for ${expression.subType}`);
}
//# sourceMappingURL=Expressions.js.map